import { render, staticRenderFns } from "./ScreeningsUpdateProfileImages.vue?vue&type=template&id=1bb98d4a&scoped=true&"
import script from "./ScreeningsUpdateProfileImages.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateProfileImages.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateProfileImages.vue?vue&type=style&index=0&id=1bb98d4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb98d4a",
  null
  
)

export default component.exports